import React from 'react'

import { Box } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { CustomTheme } from '../../theme/utils'

interface B2CCardPreHeaderProps {
  cardId: string
  children: React.ReactNode
}

const useStyles = makeStyles((theme: CustomTheme) => {
  return createStyles({
    root: {
      '& .b2c-alert': { width: '100%' },
      '& .MuiAlert-root': { borderRadius: 0, paddingLeft: theme.spacing(3) },
    },
  })
})

export default function B2CCardPreHeader({ cardId, children }: B2CCardPreHeaderProps) {
  const classes = useStyles()

  return (
    <Box className={classes.root} data-hook="card-pre-header">
      {children}
    </Box>
  )
}
